import { Link } from "react-router";

const AboutSection = () => {
  

    return (
        <section id="about" className="py-16 bg-gradient-to-br from-white to-secondary-50">
            <div className="container mx-auto px-4 max-w-6xl">
                

                {/* Section Header */}
                <div className="text-center mb-12">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-6">
                        About Prof. Bihari Lal Sharma
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-accent-500 mx-auto mb-8"></div>
                </div>

                {/* Main Content - Horizontal Layout */}
                <div className="mb-16">
                    <div className="bg-white rounded-3xl p-8 lg:p-12 shadow-soft">
                        <div className="max-w-none">
                            <p className="text-lg text-secondary-700 leading-relaxed mb-6">
                                <span className="text-heritage-maroon font-bold text-xl">
                                    Prof. Bihari Lal Sharma
                                </span>
                                {" "}is a distinguished academician, administrator, and eminent scholar of{" "}
                                <span className="font-bold text-heritage-maroon">Jyotish (Indian Astronomy and Astrology)</span>{" "}
                                with over 29+ years of experience in teaching, research, and academic leadership. Born on 1 June 1966, he belongs to Jhandutta, District Bilaspur, Himachal Pradesh. He is currently serving as the{" "}
                                <span className="font-bold text-heritage-maroon">Vice-Chancellor of Sampurnanand Sanskrit Vishwavidyalaya, Varanasi</span>. He is widely recognised for his contributions to Sanskrit education and the advancement of traditional Indian knowledge systems.
                            </p>
                            
                            <p className="text-lg text-secondary-700 leading-relaxed mb-6">
                                Prof. Sharma earned his{" "}
                                <span className="font-bold text-heritage-maroon">Ph.D. (Vidya-Varidhi) in Jyotish (Sanskrit)</span>{" "}
                                from Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeeth in 1999 and qualified the{" "}
                                <span className="font-bold text-heritage-maroon">UGC-NET in Jyotish (Sanskrit)</span>{" "}
                                in 1997. His academic excellence was recognized early when he was awarded the{" "}
                                <span className="font-bold text-heritage-maroon">Gold Medal for securing the first position across all disciplines of the university</span>{" "}
                                in 1993.
                            </p>

                            <p className="text-lg text-secondary-700 leading-relaxed mb-6">
                                Throughout his distinguished career, he has served in various academic and administrative capacities, including{" "}
                                <span className="font-bold text-heritage-maroon">Lecturer, Senior Lecturer, Reader, Associate Professor, and Professor</span>{" "}
                                in the Department of Jyotish at Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeeth, New Delhi. Since August 2023, he has been leading{" "}
                                <span className="font-bold text-heritage-maroon">Sampurnanand Sanskrit Vishwavidyalaya</span>, one of the world's oldest and largest Sanskrit universities.
                            </p>

                            <p className="text-lg text-secondary-700 leading-relaxed mb-6">
                                Prof. Sharma has made significant contributions to{" "}
                                <span className="font-bold text-heritage-maroon">academic governance and institutional development</span>{" "}
                                through his participation in Senates, Academic Councils, Boards of Studies, Examination Boards, Planning and Monitoring Boards, and various{" "}
                                <span className="font-bold text-heritage-maroon">selection and promotion committees</span>{" "}
                                of universities and public service commissions. He has also been actively associated with major national research initiatives, including the{" "}
                                <span className="font-bold text-heritage-maroon">SAP (DRS-I, DRS-II, and DRS-III)</span>{" "}
                                projects.
                            </p>

                            <p className="text-lg text-secondary-700 leading-relaxed mb-6">
                                In recognition of his outstanding scholarship and service to Sanskrit and Jyotish studies, he has received numerous honors, including the{" "}
                                <span className="font-bold text-heritage-maroon">
                                    Jyotish Martand Samman
                                </span>,{" "}
                                <span className="font-bold text-heritage-maroon">
                                    Shri Sharada Shatabdi Puraskar
                                </span>,{" "}
                                <span className="font-bold text-heritage-maroon">
                                    Kashi Ratna Puraskar
                                </span>,{" "}
                                <span className="font-bold text-heritage-maroon">
                                    Vishishta Samman
                                </span>,{" "}
                                <span className="font-bold text-heritage-maroon">
                                    Gold Shield Nakshatra
                                </span>, and{" "}
                                <span className="font-bold text-heritage-maroon">
                                    Pratibha Puraskar
                                </span>.
                            </p>
                        </div>
                    </div>
                </div>

                

                {/* Quick Navigation to Other Sections */}
                <div className="text-center my-2 pb-3">
                    <h3 className="text-heading-lg font-serif text-heritage-maroon mb-6">
                        Explore More
                    </h3>
                    <div className="flex flex-wrap justify-center gap-4">
                       
                        <Link 
                            to="/research"
                            className="bg-white px-6 py-3 rounded-xl shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 text-primary-600 font-semibold flex items-center"
                        >
                           📚 Research Articles & Books
                        </Link>
                        <Link 
                            to="/gallery"
                            className="bg-white px-6 py-3 rounded-xl shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 text-primary-600 font-semibold flex items-center"
                        >
                            📸 Photo Gallery
                        </Link>
                    </div>
                </div>

                {/* Vision Statement */}
                <div className="text-center">
                    <div className="bg-gradient-to-r from-heritage-maroon to-primary-600 rounded-3xl p-8 text-white shadow-heritage">
                        <h3 className="text-heading-lg font-serif mb-4">
                            Vision for the Future
                        </h3>
                        <p className="text-lg leading-relaxed max-w-4xl mx-auto mb-6">
                           To advance Sanskrit and Jyotish as vibrant fields of knowledge by fostering research, innovation, and meaningful dialogue, while connecting India’s timeless wisdom with the needs of the modern world.
                        </p>
                       
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
